import styled from 'styled-components';
import { mq } from '@stylesheets/tools';

export const StyledSplineScene = styled.div`
  width: 100%;
  height: 70vh;

  ${mq('l')} {
    height: unset;
  }
`;
